import {createStore} from '@ngneat/elf';
import {entitiesPropsFactory, withEntities} from '@ngneat/elf-entities';
import {withRequestsStatus} from '@ngneat/elf-requests';
import {withPagination} from '@ngneat/elf-pagination';

import {Waste, WasteFamily} from '@store/settings/wasteFamilies/wasteFamilies.model';

const {withWasteEntities} = entitiesPropsFactory('waste');

export const wasteFamiliesStore = createStore(
  {name: 'waste-families'},
  withEntities<WasteFamily>(),
  withWasteEntities<Waste>(),
  withPagination(),
  withRequestsStatus(),
);